import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';

import { TextChoiceAnswerOption } from '@app/gen/community';

interface ContentSurveysChoiceOption {
  label: {
    option?: TextChoiceAnswerOption;
  };
  value: string;
}

export const ContentSurveysChoiceLabel = ({
  option,
}: ContentSurveysChoiceOption['label']) => {
  return (
    <Box display="flex" flexDirection="column" gap="12">
      {option?.text_value && (
        <Typography variant="body3">{option?.text_value}</Typography>
      )}
    </Box>
  );
};
